import { useEffect, useState } from 'react';
import { useNavigate } from '@usas/ui-web/wrappers/ReactRouterDom';

import OrgUnitAdminUserConstants from '../OrgUnitAdminUserConstants';
import EntryNavLinks from '../../EntryNavLinks';
import MyMeetsNavLinks from '../../../myMeets/MyMeetsNavLinks';

import useOmeMeetOrgUnitEntryData from '../../../../state/omeMeetOrgUnitEntry/UseOmeMeetOrgUnitEntryData';
import useOmeMeetOrgUnitEntryInfoData from '../../../../state/omeMeetOrgUnitEntryInfo/UseOmeMeetOrgUnitEntryInfoData';
import useOmeMeetOrgUnitEntryRosterPermissionsData from '../../../../state/omeMeetOrgUnitEntryRosterPermissions/UseOmeMeetOrgUnitEntryRosterPermissionsData';
import useMyMeetsFiltersData from '../../../../state/myMeetsFilters/UseMyMeetsFiltersData';

import useMeetData from '@usas/ui-web/state/meet/UseMeetData';
import useSelectOrgUnitData from '@usas/ui-web/state/selectOrgUnit/UseSelectOrgUnitData';
import useLeftNavModalData from '@usas/ui-web/state/leftNavModal/UseLeftNavModalData';

import { credentialsIsComplete, meetInfoIsComplete, rosterEntriesIsComplete } from '../../../../components/leftNavigationOmeTeamEntry/LeftNavValidation';

const INITIAL_VIEW_STATE = {
  reportParameters: { omeMeetOrgUnitEntryId: '' },
  contextId: '',
  routeName: ''
};

const useOrgUnitAdminReportingMyMeets = () => {
  const navigate = useNavigate();
  const [viewState, setViewState] = useState(INITIAL_VIEW_STATE);
  const { meetState } = useMeetData();
  const { omeMeetOrgUnitEntryState } = useOmeMeetOrgUnitEntryData();
  const { omeMeetOrgUnitEntryInfoState } = useOmeMeetOrgUnitEntryInfoData();
  const { omeMeetOrgUnitEntryRosterPermissionsState } = useOmeMeetOrgUnitEntryRosterPermissionsData();
  const { selectOrgUnitState } = useSelectOrgUnitData();
  const { myMeetsFiltersState } = useMyMeetsFiltersData();
  const { leftNavModalState, setLeftNavModalState } = useLeftNavModalData();
  const [state, setState] = useState({ submitButton: '', tryRedirect: false, error: '' });

  const onNextButtonClicked = (e) => {
    if (e?.preventDefault) {
      e.preventDefault();
    }
    setState({ ...state, submitButton: OrgUnitAdminUserConstants.CONTINUE, tryRedirect: true, error: '' });
  };

  const onSaveAndExitButtonClicked = (e) => {
    if (e?.preventDefault) {
      e.preventDefault();
    }
    setState({ ...state, submitButton: OrgUnitAdminUserConstants.SAVE_AND_EXIT, tryRedirect: true, error: '' });
  };

  const onBackButtonClicked = (e) => {
    if (e?.preventDefault) {
      e.preventDefault();
    }
    setState({ ...state, submitButton: OrgUnitAdminUserConstants.BACK, tryRedirect: true, error: '' });
  };

  useEffect(() => {
    setLeftNavModalState({ ...leftNavModalState, formStateSaved: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (omeMeetOrgUnitEntryState.objData.omeMeetOrgUnitEntryId && meetState.objData.meetId) {
      setViewState({
        ...viewState,
        reportParameters: { omeMeetOrgUnitEntryId: omeMeetOrgUnitEntryState.objData.omeMeetOrgUnitEntryId },
        contextId: meetState.objData.meetId,
        routeName: 'OME_TEAMENTRY_REPORTING'
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [omeMeetOrgUnitEntryState, meetState]);

  useEffect(() => {
    if (state.tryRedirect === true) {
      if (state.submitButton === OrgUnitAdminUserConstants.CONTINUE) {
        if (meetInfoIsComplete(omeMeetOrgUnitEntryInfoState.objData, omeMeetOrgUnitEntryRosterPermissionsState.objData) === false ||
          rosterEntriesIsComplete(omeMeetOrgUnitEntryInfoState.objData) === false ||
          credentialsIsComplete(omeMeetOrgUnitEntryInfoState.objData) === false) {
          setState({ ...state, tryRedirect: false, error: 'Meet Info, Roster Entries, Relay Entries, and Credentials must be complete before continuing to Submit.' });
        }
        else {
          navigate(EntryNavLinks.OU_ADMIN_PURCHASES);
        }
      }
      else if (state.submitButton === OrgUnitAdminUserConstants.SAVE_AND_EXIT) {
        navigate(MyMeetsNavLinks.MEET_ENTRY_TEAM, { state: { selectOrgUnitState: selectOrgUnitState, myMeetsFiltersState: myMeetsFiltersState } });
      }
      else if (state.submitButton === OrgUnitAdminUserConstants.BACK) {
        navigate(EntryNavLinks.OU_ADMIN_CREDENTIALS);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  return { ...viewState, state, onNextButtonClicked, onSaveAndExitButtonClicked, onBackButtonClicked };
};

export default useOrgUnitAdminReportingMyMeets;